module.exports = __webpack_public_path__ + "static/media/impltech.addf452c.jpg";